export const MODULE_NAME = 'push-api';
export const PUSH_API_ROUTE = `/${MODULE_NAME}`;
